import { cn } from "@/lib/utils";

interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
}

export function Section({ children, className, id }: SectionProps) {
  return (
    <section id={id} className={cn("py-16 md:py-24", className)}>
      <div className="container">{children}</div>
    </section>
  );
}

export function SectionHeader({
  title,
  subtitle,
  className,
  as: Heading = "h2",
}: {
  title: string;
  subtitle?: string;
  className?: string;
  as?: "h1" | "h2";
}) {
  return (
    <div className={cn("text-center mb-10 md:mb-14", className)}>
      <Heading className="font-display text-3xl md:text-4xl font-semibold text-balance">{title}</Heading>
      {subtitle && <p className="text-muted-foreground mt-3 max-w-xl mx-auto">{subtitle}</p>}
    </div>
  );
}
